import React, { useContext } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetCampaignLogs, useGetCampaign } from "../../api/campaigns";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import CampaignLogsTable from "./CampaignLogsTable";
import { Group, Paper, Stack, Text } from "@mantine/core";
import { usePageTitle } from "../../services/HeaderTitleContext";

const CampaignLogs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1", 10);

  const statusParam = searchParams.get("status");
  const statusFilter = statusParam ? statusParam.split(",") : [];

  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);
  const { id } = useParams();

  const { data: campaign } = useGetCampaign({ eventId, id });
  const { data, isPending } = useGetCampaignLogs({
    eventId,
    id,
    page,
    status: statusParam || null,
  });

  usePageTitle(campaign?.subject ? `Logs - ${campaign.subject}` : "Logs");

  const { stats = {}, logs = {} } = data ?? {};

  const handlePageChange = (newPage) => {
    setSearchParams((params) => {
      params.set("page", newPage.toString());
      return params;
    });
  };

  const handleStatusFilterChange = (status) => {
    setSearchParams((searchParams) => {
      if (!status || status.length === 0) {
        searchParams.delete("status");
        return searchParams;
      }
      searchParams.set("status", status);
      searchParams.set("page", 1);
      return searchParams;
    });
  };

  return (
    <>
      <Paper p="lg" withBorder radius="md" mb="lg">
        <Group justify="space-around" grow>
          <Stack align="center" gap={4}>
            <Text size="xl" fw={700}>
              {stats.total}
            </Text>
            <Text size="sm" c="dimmed">
              Total Sent
            </Text>
          </Stack>

          <Stack align="center" gap={4}>
            <Text size="xl" fw={700} c="green">
              {stats.delivered}
            </Text>
            <Text size="sm" c="dimmed">
              Delivered
            </Text>
          </Stack>

          <Stack align="center" gap={4}>
            <Text size="xl" fw={700} c="blue">
              {stats.opened}
            </Text>
            <Text size="sm" c="dimmed">
              Opened
            </Text>
          </Stack>

          <Stack align="center" gap={4}>
            <Text size="xl" fw={700} c="red">
              {stats.failed}
            </Text>
            <Text size="sm" c="dimmed">
              Failed
            </Text>
          </Stack>
        </Group>
      </Paper>

      <CampaignLogsTable
        fetching={isPending}
        records={logs?.data || []}
        page={page}
        onPageChange={handlePageChange}
        recordsPerPage={logs?.pagination?.perPage || 10}
        totalRecords={logs?.pagination?.total || 0}
        statusFilter={statusFilter}
        handleStatusFilterChange={handleStatusFilterChange}
      />
    </>
  );
};

export default CampaignLogs;
